import React from 'react';
import styled from '@emotion/styled';

interface IPlaylistRow {
  id: number;
  title: string;
  count: number;
  onClick: (id: number) => void;
}

export const PlaylistRow = ({
  id,
  title,
  count,
  onClick,
}: IPlaylistRow & any) => (
  <Playlist onClick={() => onClick(id)}>
    <PlaylistInfo>{title}</PlaylistInfo>
    <PlaylistInfo>{count}곡</PlaylistInfo>
  </Playlist>
);

export const PlaylistWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 224px;
  border-radius: 5px;
  background-color: #f1f1f1;
  padding: 15px;
  overflow-x: hidden;
  overflow-y: scroll;

  html[color-mode='dark'] & {
    background-color: rgba(216, 216, 216, 0.05);
  }
`;

const Playlist = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-radius: 7px;
  background-color: #d8d8d8;
  border: solid 1px #d8d8d8;
  padding: 13px 20px;
  margin-bottom: 15px;
  cursor: pointer;

  &:last-child {
    margin-bottom: 0;
  }

  html[color-mode='dark'] & {
    background-color: #3b4352;
    border: solid 1px #3b4352;
  }

  &:hover {
    border: solid 1px #0a62ba;
    background-color: #ffffff;

    html[color-mode='dark'] & {
      background-color: #2e3137;
      border: solid 1px #0a62ba;
    }
  }
`;

const PlaylistInfo = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #1e1e1e;

  html[color-mode='dark'] & {
    color: white;
  }

  &:hover {
    color: #0a62ba;
  }
`;
